<template>
   <div class="main">
      <div class="container-scroller">
         <div v-if="loading" id="loading" class="loading_full">
            Loading&#8230;
         </div>
         <!-- partial:partials/_navbar.html -->
         <nav
            class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row"
         >
            <div
               class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start"
            >
               <div class="me-3">
                  <button
                     class="navbar-toggler navbar-toggler align-self-center"
                     type="button"
                     data-bs-toggle="minimize"
                  >
                     <span class="icon-menu"></span>
                  </button>
               </div>
               <div>
                  <router-link class="navbar-brand brand-logo" to="/">
                     <img src="assets/images/logo.png" alt="logo" />
                  </router-link>

                  <router-link class="navbar-brand brand-logo-mini" to="/">
                     <img src="assets/images/logo.png" alt="logo" />
                  </router-link>
               </div>
            </div>
            <div class="navbar-menu-wrapper d-flex align-items-top">
               <ul class="navbar-nav">
                  <li
                     class="nav-item font-weight-semibold d-none d-lg-block ms-0"
                  ></li>
               </ul>
               <ul class="navbar-nav ms-auto">
                  <li class="nav-item dropdown d-none d-lg-block user-dropdown">
                     <a
                        class="nav-link"
                        id="UserDropdown"
                        href="javascript:void(0)"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                     >
                        <img
                           class="img-xs rounded-circle"
                           src="assets/images/user.png"
                           alt="Imagen de perfil"
                        />
                     </a>
                     <div
                        class="dropdown-menu dropdown-menu-right navbar-dropdown"
                        aria-labelledby="UserDropdown"
                     >
                        <div class="dropdown-header text-center">
                           <img
                              class="img-md rounded-circle"
                              src="assets/images/user.png"
                              alt="Imagen de perfil"
                           />
                           <p class="mb-1 mt-3 font-weight-semibold">
                              {{ session.usuario.usuario.nombres }}
                           </p>
                           <p class="fw-light text-muted mb-0">
                              {{ session.usuario.usuario.email }}
                           </p>
                        </div>
                        <router-link to="/perfil" class="dropdown-item"
                           ><i
                              class="dropdown-item-icon mdi mdi-account-outline text-primary me-2"
                           ></i>
                           Mi perfil
                        </router-link>
                        <a
                           v-on:click="set_logout"
                           href="javascript:void(0)"
                           class="dropdown-item"
                           ><i
                              class="dropdown-item-icon mdi mdi-power text-primary me-2"
                           ></i
                           >Salir</a
                        >
                     </div>
                  </li>
               </ul>
               <button
                  class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                  type="button"
                  data-bs-toggle="offcanvas"
               >
                  <span class="mdi mdi-menu"></span>
               </button>
            </div>
         </nav>
         <!-- partial -->
         <div class="container-fluid page-body-wrapper">
            <!-- partial:partials/_sidebar.html -->
            <nav class="sidebar sidebar-offcanvas" id="sidebar">
               <ul class="nav">
                  <li class="nav-item">
                     <router-link class="nav-link" to="/">
                        <i class="mdi mdi-grid-large menu-icon"></i>
                        <span class="menu-title">Inicio</span>
                     </router-link>
                  </li>
                  <li class="nav-item nav-category">Servicios</li>
                  <li class="nav-item">
                     <a
                        class="nav-link"
                        data-bs-toggle="collapse"
                        href="#ui-basic"
                        aria-expanded="false"
                        aria-controls="ui-basic"
                     >
                        <i class="menu-icon mdi mdi-floor-plan"></i>
                        <span class="menu-title">Actividades</span>
                        <i class="menu-arrow"></i>
                     </a>
                     <div class="collapse" id="ui-basic">
                        <ul class="nav flex-column sub-menu">
                           <li class="nav-item">
                              <router-link to="/actividades" class="nav-link"
                                 >Actividades</router-link
                              >
                           </li>
                           <li class="nav-item">
                              <router-link
                                 to="/tarifas_actividades"
                                 class="nav-link"
                                 >Tarifas</router-link
                              >
                           </li>
                           <li class="nav-item">
                              <router-link
                                 to="/tipos_actividad"
                                 class="nav-link"
                                 >Tipos de actividad</router-link
                              >
                           </li>
                        </ul>
                     </div>
                  </li>
                  <li class="nav-item">
                     <a
                        class="nav-link"
                        data-bs-toggle="collapse"
                        href="#item-servicios_externos"
                        aria-expanded="false"
                        aria-controls="ui-basic"
                     >
                        <i class="menu-icon mdi mdi-floor-plan"></i>
                        <span class="menu-title">Servicios externos</span>
                        <i class="menu-arrow"></i>
                     </a>
                     <div class="collapse" id="item-servicios_externos">
                        <ul class="nav flex-column sub-menu">
                           <li class="nav-item">
                              <router-link
                                 to="/servicios_externos"
                                 class="nav-link"
                                 >Servicios externos</router-link
                              >
                           </li>
                        </ul>
                     </div>
                  </li>
                  <li class="nav-item">
                     <a
                        class="nav-link"
                        data-bs-toggle="collapse"
                        href="#item-paquetes"
                        aria-expanded="false"
                        aria-controls="ui-basic"
                     >
                        <i class="menu-icon mdi mdi-floor-plan"></i>
                        <span class="menu-title">Paquetes</span>
                        <i class="menu-arrow"></i>
                     </a>
                     <div class="collapse" id="item-paquetes">
                        <ul class="nav flex-column sub-menu">
                           <li class="nav-item">
                              <router-link to="/paquetes" class="nav-link"
                                 >Paquetes</router-link
                              >
                           </li>
                        </ul>
                     </div>
                  </li>
                  <li class="nav-item">
                     <router-link to="/cupones" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Cupones</span>
                     </router-link>
                  </li>
                  <li class="nav-item">
                     <router-link to="/proveedores" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Proveedores</span>
                     </router-link>
                  </li>

                  <li class="nav-item">
                     <router-link to="/agenda" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Agenda</span>
                     </router-link>
                  </li>
                  <li class="nav-item nav-category">Reservas</li>
                  <li class="nav-item">
                     <a
                        class="nav-link"
                        data-bs-toggle="collapse"
                        href="#form-elements"
                        aria-expanded="false"
                        aria-controls="form-elements"
                     >
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Reservas</span>
                        <i class="menu-arrow"></i>
                     </a>
                     <div class="collapse" id="form-elements">
                        <ul class="nav flex-column sub-menu">
                           <li class="nav-item">
                              <router-link to="/nueva_reserva" class="nav-link"
                                 >Nueva reserva</router-link
                              >
                           </li>
                           <li class="nav-item">
                              <router-link class="nav-link" to="/reservas"
                                 >Reservas</router-link
                              >
                           </li>
                        </ul>
                     </div>
                  </li>
                  <li class="nav-item">
                     <router-link to="/cotizaciones" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Cotizaciones</span>
                     </router-link>
                  </li>
                  <li class="nav-item">
                     <a
                        v-on:click="get_actividades(), get_asesores()"
                        class="nav-link"
                        data-bs-toggle="modal"
                        data-bs-target="#reportes"
                        href="javascript:void(0)"
                     >
                        <i class="menu-icon mdi mdi-chart-line"></i>
                        <span class="menu-title">Reportes</span>
                     </a>
                  </li>
                  <li class="nav-item">
                     <router-link to="/bonos" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Bonos</span>
                     </router-link>
                  </li>
                  <li v-if="permiso_recaudos" class="nav-item">
                     <router-link to="/recaudos" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Recaudos</span>
                     </router-link>
                  </li>
                  <li v-if="permiso_usuarios" class="nav-item nav-category">
                     Usuarios
                  </li>
                  <li v-if="permiso_usuarios" class="nav-item">
                     <router-link to="/usuarios" class="nav-link">
                        <i class="menu-icon mdi mdi-account-circle-outline"></i>
                        <span class="menu-title">Usuarios</span>
                     </router-link>
                  </li>
                  <li v-if="permiso_usuarios" class="nav-item">
                     <router-link to="/clientes" class="nav-link">
                        <i class="menu-icon mdi mdi-account-circle-outline"></i>
                        <span class="menu-title">Clientes</span>
                     </router-link>
                  </li>
                  <li class="nav-item nav-category">Herramientas</li>
                  <li class="nav-item">
                     <router-link to="/calendar" class="nav-link">
                        <i class="menu-icon mdi mdi-calendar"></i>
                        <span class="menu-title">Calendario</span>
                     </router-link>
                  </li>
                  <li class="nav-item">
                     <router-link to="/links" class="nav-link">
                        <i class="menu-icon mdi mdi-account-box-outline"></i>
                        <span class="menu-title">Directorio</span>
                     </router-link>
                  </li>
                  <li class="nav-item">
                     <router-link to="/documentos" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Administrativo</span>
                     </router-link>
                  </li>
                  <li
                     v-if="permiso_parametros || permiso_recursos"
                     class="nav-item nav-category"
                  >
                     Ajustes
                  </li>
                  <li v-if="permiso_cuentas" class="nav-item">
                     <router-link to="/cuentas" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Cuentas bancarias</span>
                     </router-link>
                  </li>
                  <li v-if="permiso_parametros" class="nav-item">
                     <router-link to="/parametros" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Parámetros</span>
                     </router-link>
                  </li>
                  <li v-if="permiso_parametros_comisiones" class="nav-item">
                     <router-link to="/parametrosComisiones" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Parámetros de comisiones</span>
                     </router-link>
                  </li>
                  <li v-if="permiso_recursos" class="nav-item">
                     <router-link to="/recursos" class="nav-link">
                        <i class="menu-icon mdi mdi-card-text-outline"></i>
                        <span class="menu-title">Recursos</span>
                     </router-link>
                  </li>
                  <li class="nav-item nav-category">Perfil</li>
                  <li class="nav-item">
                     <router-link to="/perfil" class="nav-link"
                        ><i
                           class="dropdown-item-icon mdi mdi-account-outline text-primary me-2"
                        ></i>
                        Mi perfil
                     </router-link>
                  </li>
                  <li class="nav-item">
                     <a
                        v-on:click="set_logout"
                        href="javascript:void(0)"
                        class="nav-link"
                        ><i
                           class="dropdown-item-icon mdi mdi-power text-primary me-2"
                        ></i
                        >Salir</a
                     >
                  </li>
               </ul>
            </nav>
            <!-- partial -->
            <div class="main-panel">
               <div class="content-wrapper">
                  <router-view :session="session" />
               </div>
               <!-- content-wrapper ends -->
               <!-- partial:partials/_footer.html -->
               <footer class="footer">
                  <div
                     class="d-sm-flex justify-content-center justify-content-sm-between"
                  >
                     <small>
                        <span
                           class="text-muted text-center text-sm-left d-block d-sm-inline-block"
                           >Premium
                           <a
                              href="https://www.bootstrapdash.com/"
                              target="_blank"
                              >Bootstrap admin template</a
                           >
                           from BootstrapDash.</span
                        >
                     </small>
                     <span
                        class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"
                        >Copyright © 2026. Todos los derechos reservados. Un
                        desarrollo
                        <a href="https://arboledadev.com" target="_blank"
                           >Arboleda Dev</a
                        ></span
                     >
                  </div>
               </footer>
               <!-- partial -->
            </div>
            <!-- main-panel ends -->
         </div>
         <!-- page-body-wrapper ends -->
         <div class="modal fade" id="reportes">
            <div class="modal-dialog modal-xl" role="document">
               <div class="modal-content">
                  <div class="modal-header text-success">
                     <h5 class="modal-title fw-bolder">Reportes</h5>
                     <button
                        type="button"
                        class="close"
                        data-bs-dismiss="modal"
                     >
                        <span>&times;</span>
                     </button>
                  </div>
                  <div class="modal-body">
                     <div v-if="loading_reporte" class="text-center">
                        <div class="loadingio-spinner-ripple-6armq16mc04">
                           <div class="ldio-2tzb8vdk7pu">
                              <div></div>
                              <div></div>
                           </div>
                        </div>
                     </div>
                     <div v-else>
                        <transition
                           v-if="reporte.tipo_reporte == null"
                           appear
                           name="slide-fade"
                        >
                           <div class="row">
                              <div class="col-lg-12">
                                 <h5 class="text-muted mb-4">
                                    <i class="fa fa-info-circle"></i>
                                    Selecciona el reporte que deseas consultar
                                 </h5>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    @click="
                                       (reporte.tipo_reporte = 1),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Reporte General
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    @click="
                                       (reporte.tipo_reporte = 2),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Reservas asesor
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    @click="
                                       (reporte.tipo_reporte = 5),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Reservas comprador
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    @click="
                                       (reporte.tipo_reporte = 6),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Reservas pasajero
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    @click="
                                       (reporte.tipo_reporte = 3),
                                          (reporte.tipo_fecha = 3)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Comentarios de reservas
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    v-if="permiso_reportes"
                                    @click="
                                       (reporte.tipo_reporte = 4),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Pagos
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    v-if="permiso_reportes"
                                    @click="
                                       (reporte.tipo_reporte = 7),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Pagos a proveedores
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    v-if="permiso_reportes"
                                    @click="
                                       (reporte.tipo_reporte = 8),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Recaudos de reservas
                                 </button>
                              </div>
                              <div class="col-lg-3 d-grid gap-2 p-1">
                                 <button
                                    v-if="permiso_reportes"
                                    @click="
                                       (reporte.tipo_reporte = 9),
                                          (reporte.tipo_fecha = 1)
                                    "
                                    class="btn btn-outline-primary btn-report"
                                 >
                                    <i
                                       class="fa-regular fa-file-excel mb-2"
                                    ></i>
                                    <br />
                                    Reservas revisadas
                                 </button>
                              </div>
                           </div>
                        </transition>

                        <transition
                           v-if="reporte.tipo_reporte != null"
                           appear
                           name="slide-fade"
                        >
                           <div class="row">
                              <div class="col-md-6 offset-md-3">
                                 <div class="mb-3">
                                    <a
                                       @click="
                                          (reporte.tipo_reporte = null),
                                             (result_reporte = null)
                                       "
                                       href="javascript:void(0)"
                                    >
                                       <i class="fa fa-chevron-left"></i>
                                       Regresar
                                    </a>
                                 </div>
                                 <div class="card card-body bordered">
                                    <div v-if="reporte.tipo_reporte != null">
                                       <h5
                                          v-if="reporte.tipo_reporte == 1"
                                          class="fw-bolder text-primary mb-4"
                                       >
                                          Reporte general
                                       </h5>
                                       <h5
                                          v-if="reporte.tipo_reporte == 2"
                                          class="fw-bolder text-primary mb-4"
                                       >
                                          Reporte por asesor
                                       </h5>
                                       <h5
                                          v-if="reporte.tipo_reporte == 3"
                                          class="fw-bolder text-primary mb-4"
                                       >
                                          Reporte por comentarios de reservas
                                       </h5>
                                       <h5
                                          v-if="reporte.tipo_reporte == 5"
                                          class="fw-bolder text-primary mb-4"
                                       >
                                          Reporte por comprador
                                       </h5>
                                       <h5
                                          v-if="reporte.tipo_reporte == 6"
                                          class="fw-bolder text-primary mb-4"
                                       >
                                          Reporte por pasajero
                                       </h5>
                                       <h5
                                          v-if="reporte.tipo_reporte == 4"
                                          class="fw-bolder text-primary mb-4"
                                       >
                                          Reporte de pagos
                                       </h5>
                                       <div
                                          v-if="
                                             reporte.tipo_reporte == 1 ||
                                             reporte.tipo_reporte == 2 ||
                                             reporte.tipo_reporte == 5 ||
                                             reporte.tipo_reporte == 6
                                          "
                                          class="ps-4 pe-4"
                                       >
                                          <div class="form-check">
                                             <input
                                                @click="result_reporte = null"
                                                v-model="reporte.tipo_fecha"
                                                class="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="flexRadioDefault1"
                                                value="1"
                                             />
                                             <label
                                                class="form-check-label"
                                                for="flexRadioDefault1"
                                             >
                                                Por fechas de registro
                                             </label>
                                          </div>
                                          <div class="form-check">
                                             <input
                                                @click="result_reporte = null"
                                                v-model="reporte.tipo_fecha"
                                                class="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="flexRadioDefault2"
                                                value="2"
                                             />
                                             <label
                                                class="form-check-label"
                                                for="flexRadioDefault2"
                                             >
                                                Por fechas de reserva
                                             </label>
                                          </div>
                                          <div class="form-check">
                                             <input
                                                @click="result_reporte = null"
                                                v-model="reporte.tipo_fecha"
                                                class="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="flexRadioDefault4"
                                                value="4"
                                             />
                                             <label
                                                class="form-check-label"
                                                for="flexRadioDefault4"
                                             >
                                                Por fechas de aprobación
                                             </label>
                                          </div>
                                       </div>
                                       <div
                                          class="form-group"
                                          v-if="reporte.tipo_fecha == 3"
                                       >
                                          <label>Estado de la reserva</label>
                                          <select
                                             v-model="reporte.estado"
                                             class="form-control"
                                          >
                                             <option value="0">
                                                Pendiente
                                             </option>
                                             <option value="1">Aprobada</option>
                                             <option value="3">Anulada</option>
                                          </select>
                                          <small class="text-muted"
                                             >Es posible que debas modificar el
                                             excel eliminando reservas
                                             duplicadas para cuadrar con el
                                             total de reservas que indica el
                                             sistema</small
                                          >
                                       </div>
                                       <div v-if="reporte.tipo_reporte == 2">
                                          <div
                                             v-if="permiso_reportes"
                                             class="form-group"
                                          >
                                             <label>Asesor</label>
                                             <v-select
                                                v-model="reporte.asesor"
                                                label="nombre_completo"
                                                :options="usuarios"
                                                :clearable="true"
                                             ></v-select>
                                          </div>
                                          <div v-else>
                                             <div class="alert alert-info">
                                                <i
                                                   class="fa fa-info-circle"
                                                ></i>
                                                Se consultarán tus reservas.
                                             </div>
                                          </div>
                                       </div>
                                       <div v-if="reporte.tipo_reporte == 5">
                                          <div class="form-group">
                                             <label>Comprador</label>
                                             <v-select
                                                v-model="reporte.cliente"
                                                @search="getClientes"
                                                label="cliente"
                                                :options="clientes"
                                                :clearable="false"
                                             >
                                                <template
                                                   v-slot:no-options="{
                                                      search,
                                                      searching,
                                                   }"
                                                >
                                                   <template v-if="searching">
                                                      No se encontraron
                                                      resultados para
                                                      <em>{{ search }}</em
                                                      >.
                                                   </template>
                                                   <em
                                                      v-else
                                                      style="opacity: 0.5"
                                                      >Empieza a escribir el
                                                      nombre o número de
                                                      identificacion del
                                                      cliente</em
                                                   >
                                                </template>
                                             </v-select>
                                          </div>
                                       </div>
                                       <div v-if="reporte.tipo_reporte == 6">
                                          <div class="form-group">
                                             <label>Comprador</label>
                                             <v-select
                                                v-model="reporte.cliente"
                                                @search="getClientes"
                                                label="cliente"
                                                :options="clientes"
                                                :clearable="false"
                                             >
                                                <template
                                                   v-slot:no-options="{
                                                      search,
                                                      searching,
                                                   }"
                                                >
                                                   <template v-if="searching">
                                                      No se encontraron
                                                      resultados para
                                                      <em>{{ search }}</em
                                                      >.
                                                   </template>
                                                   <em
                                                      v-else
                                                      style="opacity: 0.5"
                                                      >Empieza a escribir el
                                                      nombre o número de
                                                      identificacion del
                                                      cliente</em
                                                   >
                                                </template>
                                             </v-select>
                                          </div>
                                       </div>
                                       <div
                                          v-if="reporte.tipo_reporte === 8"
                                          class="mb-3"
                                       >
                                          <label>Tipo de Fecha</label>
                                          <select
                                             v-model="reporte.tipo_fecha"
                                             class="form-control"
                                          >
                                             <option value="1">
                                                Fecha de registro de recaudo
                                             </option>
                                             <option value="2">
                                                Fecha de viaje o actividad
                                             </option>
                                          </select>
                                       </div>
                                       <div class="form-group">
                                          <label>Desde</label>
                                          <input
                                             v-on:change="result_reporte = null"
                                             v-model="reporte.desde"
                                             class="form-control"
                                             type="date"
                                          />
                                       </div>
                                       <div class="form-group">
                                          <label>Hasta</label>
                                          <input
                                             v-on:change="result_reporte = null"
                                             :min="reporte.desde"
                                             v-model="reporte.hasta"
                                             class="form-control"
                                             type="date"
                                          />
                                       </div>
                                       <div class="text-end">
                                          <button
                                             v-on:click="get_reporte"
                                             :disabled="
                                                reporte.desde == null ||
                                                reporte.hasta == null
                                             "
                                             class="btn btn-primary rounded-pill btn-sm"
                                          >
                                             <i class="fa fa-search"></i>
                                             Consultar
                                          </button>
                                          <button
                                             data-bs-dismiss="modal"
                                             class="btn btn-outline-dark rounded-pill btn-sm ms-1"
                                          >
                                             Cancelar
                                          </button>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </transition>
                        <div v-if="result_reporte != null" class="mt-4">
                           <div
                              v-if="result_reporte == 0"
                              class="alert alert-warning"
                           >
                              <i class="fa fa-info-circle"></i> No se
                              encontraron reservas.
                           </div>
                           <div v-else class="text-center">
                              <hr />
                              <span
                                 ><i class="fa fa-info-circle"></i> Se
                                 encontraron
                                 {{ result_reporte }} registros.</span
                              >
                              <div class="mt-3">
                                 <a
                                    v-bind:href="url_reporte"
                                    target="_blank"
                                    class="btn btn-success rounded-pill"
                                 >
                                    <i class="fa fa-download"></i> Descargar
                                 </a>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <button
         v-if="permiso_recaudos"
         @click="getRecaudos()"
         class="btn btn-success floating-action-button"
         type="button"
         data-bs-toggle="modal"
         data-bs-target="#floatingModal"
         aria-label="Ver Recaudos"
         data-tooltip="Ver Recaudos"
      >
         <i class="fa fa-file-invoice fa-2x"></i>
      </button>
      <div
         class="modal fade"
         id="floatingModal"
         tabindex="-1"
         aria-labelledby="floatingModalLabel"
         aria-hidden="true"
      >
         <div class="modal-dialog" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h3
                     class="modal-title text-primary fw-bolder"
                     id="floatingModalLabel"
                  >
                     Recaudos
                  </h3>
                  <button type="button" class="close" data-bs-dismiss="modal">
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body bg-light">
                  <div v-if="recaudos != null">
                     <ul class="list-group">
                        <li
                           v-for="(recaudo, index_recaudo) in recaudos"
                           :key="index_recaudo"
                           class="card card-body mb-2"
                        >
                           <div>
                              <h6 class="mb-1 text-primary text-uppercase">
                                 {{ recaudo.cuenta }}
                              </h6>

                              <p class="mb-0 text-end fw-bolder text-success">
                                 <strong>Total:</strong>
                                 {{ recaudo.totalRecaudos | currency }}
                              </p>
                           </div>
                        </li>
                        <div class="text-end mt-4 pe-2">
                           <strong>Total recaudos:</strong>
                           <h4 class="fw-bolder text-success mt-2">
                              {{ totalRecaudos | currency }}
                           </h4>
                        </div>
                     </ul>
                  </div>
               </div>
               <div class="modal-footer">
                  <button
                     type="button"
                     class="btn btn-light btm-sm"
                     data-bs-dismiss="modal"
                  >
                     Cerrar
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<style scoped>
.floating-action-button {
   position: fixed;
   right: 24px;
   bottom: 24px;
   z-index: 1030;
   border-radius: 999px;
   width: 56px;
   height: 56px;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
   transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.floating-action-button:hover,
.floating-action-button:focus-visible {
   transform: scale(1.08);
   box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25);
}

.floating-action-button::after {
   content: attr(data-tooltip);
   position: absolute;
   right: calc(100% + 12px);
   top: 50%;
   transform: translateY(-50%);
   background: rgba(33, 37, 41, 0.95);
   color: #fff;
   padding: 6px 10px;
   border-radius: 6px;
   font-size: 12px;
   line-height: 1;
   white-space: nowrap;
   opacity: 0;
   pointer-events: none;
   transition: opacity 0.2s ease, transform 0.2s ease;
}

.floating-action-button:hover::after,
.floating-action-button:focus-visible::after {
   opacity: 1;
   transform: translateY(-50%) translateX(-2px);
}
</style>
<script>
import $ from "jquery";
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
   name: "Main",
   data() {
      return {
         session: null,
         loading: false,
         actividades: [],
         usuarios: [],
         reporte: {
            tipo_reporte: null,
            tipo_fecha: 1,
            estado: 1,
            usuario: null,
            desde: null,
            hasta: null,
            asesor: null,
            cliente: null,
         },
         clientes: [],
         loading_reporte: false,
         result_reporte: null,
         url_reporte: null,
         recaudos: null,
         totalRecaudos: 0,
         permiso_usuarios: false,
         permiso_parametros: false,
         permiso_recursos: false,
         permiso_reportes: false,
         permiso_recaudos: false,
      };
   },
   created: function () {
      var session = localStorage.getItem("sess_vyt_backoffice");
      session = JSON.parse(session);
      this.session = session;
      this.permiso_usuarios = this.session.usuario.usuario.permisos.GUSUARIOS;
      this.permiso_parametros =
         this.session.usuario.usuario.permisos.GPARAMETROS;
      this.permiso_parametros_comisiones =
         this.session.usuario.usuario.permisos.GPARAMETROSCOMISIONES;
      this.permiso_recursos = this.session.usuario.usuario.permisos.GRECURSOS;
      this.permiso_reportes = this.session.usuario.usuario.permisos.GREPORTES;
      this.permiso_cuentas = this.session.usuario.usuario.permisos.GCUENTAS;
      this.permiso_recaudos = this.session.usuario.usuario.permisos.GRECAUDOS;
   },
   methods: {
      get_actividades: function (search = null) {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               search: search,
            },
         };
         axios
            .get(vm.$base_url + "servicios/actividades_list", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.actividades = response.data.data.actividades;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Actividades",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Actividades",
                  text: error,
               });
               vm.loading = false;
            });
      },
      get_asesores: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
         };
         axios
            .get(vm.$base_url + "admin/usuarios", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.usuarios = response.data.data.usuarios;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Usuarios",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Usuarios",
                  text: error,
               });
               vm.loading = false;
            });
      },
      get_reporte: function () {
         let idAsesor = null;
         if (this.reporte.tipo_reporte == 2) {
            if (!this.permiso_reportes) {
               idAsesor = this.session.usuario.usuario.id_usuario;
            } else {
               idAsesor = this.reporte.asesor.id_usuario;
            }
         }
         let idCliente = null;
         if (
            (this.reporte.tipo_reporte == 5 ||
               this.reporte.tipo_reporte == 6) &&
            this.reporte.cliente != null
         ) {
            idCliente = this.reporte.cliente.id_cliente;
         }
         let url = null;

         switch (this.reporte.tipo_reporte) {
            case 4:
               url = this.$base_url + "reservas/reporte_pagos";
               break;
            case 7:
               url = this.$base_url + "reservas/reporte_pagos_proveedor";
               break;
            case 8:
               url = this.$base_url + "reservas/reporte_recaudos";
               break;
            case 9:
               url = this.$base_url + "reservas/reporteRevisadas";
               break;
            default:
               url = this.$base_url + "reservas/reporte";
               break;
         }

         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               tipo_reporte: this.reporte.tipo_reporte,
               tipo_fecha: this.reporte.tipo_fecha,
               estado: this.reporte.estado,
               desde: this.reporte.desde,
               hasta: this.reporte.hasta,
               asesor: idAsesor,
               cliente: idCliente,
            },
         };
         axios
            .get(url, config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.result_reporte = response.data.results;
                  vm.url_reporte = response.data.url;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Reporte",
                     text: response.data.message,
                  });
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Reporte",
                  text: error,
               });
               vm.loading_reporte = false;
            })
            .finally(() => {
               vm.loading = false;
               vm.loading_reporte = false;
            });
      },
      getClientes: function (search) {
         if (search.length < 3) {
            return false;
         }
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
            params: {
               search: search,
            },
         };
         axios
            .get(vm.$base_url + "clientes/clientes", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.clientes = response.data.data.clientes;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Clientes",
                     text: response.data.message,
                  });
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Clientes",
                  text: error,
               });
            });
      },
      getRecaudos: function () {
         const vm = this;
         vm.loading = true;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
         };
         axios
            .get(vm.$base_url + "reservas/recaudos_reservas", config, {
               headers: headers,
            })
            .then((response) => {
               if (response.data.status) {
                  vm.recaudos = response.data.data.recaudos;
                  vm.totalRecaudos = response.data.data.total;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Recaudos",
                     text: response.data.message,
                  });
               }
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Recaudos",
                  text: error,
               });
            })
            .finally(() => {
               vm.loading = false;
            });
      },
      set_logout: function () {
         localStorage.removeItem("sess_vyt_backoffice");
         location.reload();
      },
   },
   mounted: function () {
      var body = $("body");
      $('[data-bs-toggle="minimize"]').on("click", function () {
         if (
            body.hasClass("sidebar-toggle-display") ||
            body.hasClass("sidebar-absolute")
         ) {
            body.toggleClass("sidebar-hidden");
         } else {
            body.toggleClass("sidebar-icon-only");
         }
      });
      $('[data-bs-toggle="offcanvas"]').on("click", function () {
         $(".sidebar-offcanvas").toggleClass("active");
      });
   },
};
</script>
